import get from 'transmute/get';
import { AUTO_REPLY_SUPPRESSED_MESSAGE } from '../constants/messageTypes';
export const isAutoReplySuppressedMessage = message => {
  return get('@type', message) === AUTO_REPLY_SUPPRESSED_MESSAGE;
};